import {Client} from "./client.model";

/**
 * Model reprezentujący zdefiniowaną usługę w ramach Pakietu Opieki (Abonamentu).
 * Stanowi element katalogu usług, z którego klinika buduje swoje plany subskrypcyjne dla pacjentów.
 */
export class CarePlanService {


  /** Globalnie unikalny identyfikator usługi. */
  public uuid: string;


  /** Identyfikator użytkownika, który utworzył tę usługę w słowniku. */
  public authorUUID: string;

  /** Identyfikator użytkownika, który jako ostatni edytował parametry usługi. */
  public editorUUID: string;

  /** Data i czas utworzenia rekordu. */
  public created: Date;

  /** Data i czas ostatniej modyfikacji. */
  public modified: Date;

  /** Data usunięcia.
   */
  public deleted: Date;


  /** Nazwa usługi wyświetlana w systemie.
   */
  public name: string;

  /** Czas trwania usługi (w minutach).
   */
  public time: number;

  /** Szczegółowy opis usługi (widoczny w szczegółach planu abonamentowego). */
  public description: string;


  /** Identyfikator klienta, do którego przypisana jest ta usługa.
   */
  public vClientId: number;

  /** Pełny obiekt klienta powiązanego z tą usługą. */
  public vClient: Client;
}
